import NewslettersEdit from "./NewslettersEdit";

export default NewslettersEdit;
